/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Tested_NameInputs */

const en_marketing_feature_tested_name = /** @type {(inputs: Marketing_Feature_Tested_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tested and typed`)
};

const es_marketing_feature_tested_name = /** @type {(inputs: Marketing_Feature_Tested_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probado y tipado`)
};

const fr_marketing_feature_tested_name = /** @type {(inputs: Marketing_Feature_Tested_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testé et typé`)
};

/**
* | output |
* | --- |
* | "Tested and typed" |
*
* @param {Marketing_Feature_Tested_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_tested_name = /** @type {((inputs?: Marketing_Feature_Tested_NameInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Tested_NameInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_tested_name(inputs)
	if (locale === "es") return es_marketing_feature_tested_name(inputs)
	return fr_marketing_feature_tested_name(inputs)
});